/**
 * Labstep
 *
 * @module components/Entity/Form/ShowEdit/Name
 * @desc ShowEditName for Entity
 */

import { fieldEntityName } from 'labstep-web/components/Entity/Form/fields';
import { FormShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import type React from 'react';
import type { EntityFormShowEditNameProps } from './types';

export const EntityFormShowEditName: React.FC<
  EntityFormShowEditNameProps
> = ({ entity }) => (
  <FormShowEditText
    entityName={entity.entityName}
    entity={entity}
    field={{ ...fieldEntityName(entity.entityName), header: false }}
  >
    {entity.name}
  </FormShowEditText>
);
